import type { Airport } from '../../lib/api';
import { flagEmoji } from '../../lib/format';
import { Icon } from '../Icon/Icon';
import './route.css';

type End = Pick<Airport, 'iata' | 'city' | 'countryCode'>;

export interface RouteStripProps {
  from: End;
  to: End;
  /** Navy on white (S2's card); default is white on the board. */
  light?: boolean;
}

/** 🇪🇸 BARCELONA BCN ──✈── LHR LONDON 🇬🇧 (S2, S5). */
export function RouteStrip({ from, to, light }: RouteStripProps) {
  return (
    <div className={`route${light ? ' route--light' : ''}`}>
      <div>
        <span className="route__code">{from.iata}</span>
        <span className="route__city">
          {flagEmoji(from.countryCode)} {from.city}
        </span>
      </div>
      <div className="route__mid" aria-hidden="true">
        <span />
        <Icon name="plane" />
        <span />
      </div>
      <div className="route__end--to">
        <span className="route__code">{to.iata}</span>
        <span className="route__city">
          {flagEmoji(to.countryCode)} {to.city}
        </span>
      </div>
    </div>
  );
}
